(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["px-workplace-wellness"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const link=event.target.closest('.px-ww__choose');
  if(!link)return;
  const root=link.closest('.px-ww');
  const select=root.querySelector('select[name="contact[Experience]"]');
  const option=Array.from(select.options).find(item=>item.dataset.program===link.dataset.program);
  if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}
});

  } catch(e) { console.error(e); }
})();
})();
